/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useMemo, useContext } from 'react'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  retrieveHeatCurveDOM,
  deleteHeatCurveDOM,
  saveHeatCurveDOM,
  // retrieveHeatCurveSeason,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, InputNumber } from 'antd'

import * as Actions from 'core/EventActions'

import CommonScreen from 'admin/component/CommonScreen'

import MarginAnalysisUtilityUnitSelection from './../../MarginAnalysisUtilityUnitSelection'
import { PNodeZoneContext } from 'context'

const title = 'Heat Curve'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const headers = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  numCol({
    ident: 'endMw',
    display: 'End MW',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(seasonChioce),
  }),
  numCol({
    ident: 'acoefficient',
    display: 'A-Coefficient',
    isFiltered: true,
    displayFormat: '0.00000',
    // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'bcoefficient',
    display: 'B-Coefficient',
    isFiltered: true,
    displayFormat: '0.00000',
    // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'ccoefficient',
    display: 'C-Coefficient',
    isFiltered: true,
    displayFormat: '0.000000',
    // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'dcoefficient',
    display: 'D-Coefficient',
    isFiltered: true,
    displayFormat: '0.000000',
    // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'perfFactor',
    display: 'Performance Factor',
    isFiltered: true,
    // sortOrder: 'asc',
    displayFormat: '0.000000',
    width: 200,
  }),
  modifierCol,
  modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const HeatRateCurveDOM = ({ envConfig, actionPermits }) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  // const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '90px 100px 100px 150px 100px 150px 100px 100px 150px 150px',
          gridGap: '5px',
        }}
      >
        <Label>Unit:</Label>
        <div style={{ gridColumn: 'span 3' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: emktUnitMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
          />
        </div>
        <Label>Effective Date:</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.effectivedateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              effectivedate: date.format('YYYY-MM-DD'),
              effectivedateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        <Label>End MW :</Label>
        <InputNumber
          value={insertData.endMw}
          onChange={endMw => setInsertData({ ...insertData, endMw })}
        />
        {/* <Select
          value={insertData.season}
          onChange={value => setInsertData({ ...insertData, season: value })}
          style={{ width: '100%' }}
        >
          {Object.keys(seasonMap).map(m => (
            <Select.Option key={m} value={m}>
              {m}
            </Select.Option>
          ))}
        </Select> */}
        <Label>Performance Factor:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.perfFactor}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, perfFactor: value })
          }
        />
        <Label>A Coefficient:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.acoefficient}
          onChange={value =>
            setInsertData({ ...insertData, acoefficient: value })
          }
        />
        <Label>B Coefficient:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.bcoefficient}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, bcoefficient: value })
          }
        />
        <Label>C Coefficient:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.ccoefficient}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, ccoefficient: value })
          }
        />
        <Label>D Coefficient:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.dcoefficient}
          onChange={value =>
            setInsertData({ ...insertData, dcoefficient: value })
          }
        />
        <div
          style={{
            gridColumn: 'span 2',
            gridRowGap: '10px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            paddingLeft: '5px',
            gridColumnGap: '10px',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CriteriaRow>
  )

  const { unitIdEmktIdMap, emktIdUnitNameMap, marginUnitsList } = useContext(
    PNodeZoneContext
  )
  const emktUnitMap = unitIdEmktIdMap
  const unitEmktMap = emktIdUnitNameMap

  const headerWithFormatter = headers.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => unitEmktMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitEmktMap[rowData.unitId] ||
            unitEmktMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const withCriteria = (state, props, selectedUnits, selectedDate) => {
    return {
      date: selectedDate,
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  // writeEventActionPermission ? (
  //   <Checkbox
  //     css={{ marginLeft: '10px', minWidth: '100px' }}
  //     onChange={e => setEditMode(e.target.checked)}
  //     checked={editMode}
  //   >
  //     Edit Mode
  //   </Checkbox>
  // ) : (
  //   <div />
  // )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  // const modifySaveDataBeforeSave = (saveData, validateData) => {
  //   return saveData.map(s => ({ ...s, unitId: emktUnitMap[s.unitId] }))
  // }

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }

  return (
    <div>
      <CommonScreen
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        withoutModify={!writeEventActionPermission}
        withDelete={!writeEventActionPermission}
        allowInsert={writeEventActionPermission}
        isEditableGrid={isEditableGrid}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withUnitSelection
        withDatePickerTitle="Effective Date:"
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        withDatePicker
        title={title}
        header={headerWithFormatter}
        saveTask={saveHeatCurveDOM}
        retrieveTask={retrieveHeatCurveDOM}
        deleteTask={deleteHeatCurveDOM}
        altBy={u => u.unitId}
        sortOptions={headers}
        initialSortOptions={headers}
        widthOffset={50}
        insertComp={insertEvent && insertComp}
        insertCompHeight={120}
        onInsertEvent={b => setInsertEvent(b)}
        withImport
        importUrl="marginanalysisdata-import/generic-import"
        importData={{ importType: 'MA_HEAT_CURVE' }}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(HeatRateCurveDOM)
